import React from 'react';

const TeamPage = () => {
  const leadership = [
    {
      name: 'Dr. Genti Tahiraj',
      title: 'CEO & Co-Founder',
      image: 'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/40wtxlv020nnuu2/uploaded-images/YI9RPH0n9VsmE_d4clWM3.png',
      bio: 'Board-certified Emergency Medicine Physician with summa cum laude BS from Cumberland University and MD from University of Tennessee Health Science Center. As Chief of Medicine and CMIO at HCA Florida South/West/Central Tampa Hospital, Dr. Tahiraj enhances patient care through innovative medical data integration and strategic leadership.',
      highlights: [
        { title: 'Medical Leadership', desc: 'Chief of Medicine at HCA Florida hospitals' },
        { title: 'Technology Vision', desc: 'CMIO driving data integration innovation' },
        { title: 'Clinical Excellence', desc: 'Board-certified Emergency Medicine expert' },
      ],
    },
    {
      name: 'Sami Siddiq',
      title: 'Chief Technology Officer & Co-Founder',
      image: 'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/40wtxlv020nnuu2/uploaded-images/J4ZFZ1DbvCmfEhreveShW.png',
      bio: 'Over 18 years of expertise in Business Intelligence, data warehousing, and advanced analytics. Specializes in Data Strategy, Governance, and AI-Driven Analytics initiatives. Ensures effective data utilization to drive strategic decision-making, optimize AI models, and enhance operational efficiency across CareTap AI\'s Cloud SaaS platform.',
      highlights: [
        { title: 'Data Architecture', desc: 'Managing complex data systems across healthcare, finance, and retail sectors' },
        { title: 'AI Transformation', desc: 'Leading large-scale AI and BI transformations with proven track record' },
        { title: 'Predictive Analytics', desc: 'Spearheading AI-powered automation and interoperability solutions' },
        { title: 'Strategic Innovation', desc: 'Empowering providers, insurers, and legal firms with actionable insights' },
      ],
    },
  ];

  const boardAdvisors = [
    {
      name: 'Leon Drennan',
      title: 'Board Advisor | Former President of Physician Services at HCA',
      image: 'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/40wtxlv020nnuu2/uploaded-images/Oq7iXscyl98i4rEwTfU7M.png',
      bio: 'Over 30 years of visionary leadership in healthcare. As President of Physician Services at HCA for 12 years, Mr. Drennan spearheaded strategic oversight of staffing, infrastructure development, corporate services, revenue integrity, and internal audit across a vast network of physicians.',
      highlights: [
        'Published Author: "20/20 Leadership: A 40-Year Career in Hindsight" and "People: Your Greatest Asset or Biggest Headache?"',
        'Vision Leadership Foundation: Founder dedicated to training leaders across various sectors, currently serving as Strategic Advisor and Executive Coach',
      ],
    },
    {
      name: 'Louis Suttle',
      title: 'Board Advisor | Healthcare Operations Executive',
      image: 'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/40wtxlv020nnuu2/uploaded-images/XU_7U0lMpCcAukNUgbUXj.jpeg',
      bio: 'Over four decades of extensive healthcare industry experience. Joined PathGroup in 1998 with the objective of positioning the company as a regional leader in pathology and clinical testing services. Held leadership positions including Chief Operating Officer, Chief Compliance Officer, and EVP Chief Compliance Officer and Administration.',
      highlights: [
        'PathGroup Growth: Expanded operations through marketing, sales, and acquisitions into multiple states',
        'Recapitalization Success: Led collaborations with Primus Capital, Pritzker Private Capital, and Brentwood Capital Advisors',
        'HCA Leadership: 20 years with HCA, culminating as CEO of Columbia/HCA Nashville Regional Laboratory Services',
        'Instrumental in Allied Clinical Laboratories\' successful public offering in 1990 and growth to become the sixth largest laboratory in the United States before acquisition by LabCorp in 1994',
      ],
    },
    {
      name: 'Russ Tonnies',
      title: 'Board Advisor | Healthcare Finance Leader',
      image: 'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/40wtxlv020nnuu2/uploaded-images/_MUe7xOf6UkZ3J831GzWs.png',
      bio: '33 years in healthcare industry until retiring in 2017. Includes 20 years in pathology/clinical lab arena and 13 years in hospital sector. Founding EVP and CFO of PathGroup in 1997, playing major leadership role in growing PathGroup into a regional multistate leader in pathology and clinical lab services.',
      highlights: [
        '$2.1B Debt Negotiated: Managed various types of highly leveraged debt and leases to finance rapid growth',
        'OrNda HealthCorp Expansion: Led growth from 10 to 50 hospitals during his tenure',
        '$2.7B Revenue Scale: Achieved this proforma revenue when acquired by Tenet Healthcare in 1997',
      ],
    },
    {
      name: 'Dr. John E. Anderson',
      title: 'Board Advisor | Internal Medicine & Diabetes Care Expert',
      image: 'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/40wtxlv020nnuu2/uploaded-images/UEWD_yaakvHr3a-54z9Xe.jpeg',
      bio: 'Nationally recognized leader in internal medicine and diabetes care with decades of experience in clinical practice, hospital leadership, and national advocacy. Based at Frist Clinic in Nashville, Tennessee. Served as President of the multi-specialty clinic and held multiple leadership roles at Centennial Medical Center, an 800-bed HCA tertiary care referral hospital.',
      highlights: [
        'Hospital Leadership: Two terms as Chair of Department of Medicine and Chair of Board of Trustees',
        'Banting Medal 2013: Honored for Service as President of Medicine and Science for ADA',
        'National Speaker: Published author lecturing internationally on diabetes care outcomes',
        'Leadership Excellence: Decades of frontline experience in clinical practice',
      ],
    },
  ];

  return (
    <div className="min-h-screen pt-20">
      <section className="relative py-20 bg-gradient-to-br from-blue-900 via-cyan-900 to-blue-900 text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)', backgroundSize: '50px 50px' }} />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Meet the Team</h1>
          <p className="text-xl md:text-2xl text-cyan-100 max-w-4xl mx-auto mb-6">Discover the visionary leaders and advisors driving innovation in healthcare AI and data intelligence</p>
          <p className="text-lg text-cyan-200 max-w-3xl mx-auto">Our team comprises a unique blend of seasoned professionals, including AI ethicists, clinical data scientists, medical practitioners, and software engineers. Each member brings a wealth of experience from diverse backgrounds, all united by a shared passion for leveraging technology to solve complex healthcare challenges.</p>
        </div>
      </section>

      {/* Mission Statement */}
      <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-r from-blue-50 to-cyan-50 rounded-2xl p-8 md:p-12 border border-blue-200">
            <p className="text-lg text-gray-700 leading-relaxed mb-6">At the core of our mission is the commitment to transforming healthcare through intelligent data utilization. We believe that by unlocking the power of healthcare data with cutting-edge artificial intelligence, we can pave the way for more accurate diagnostics, personalized treatment plans, and improved patient outcomes.</p>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">What truly sets our team apart is our deep-seated expertise in both the intricacies of healthcare systems and the complexities of AI and data science. Our leadership possesses decades of combined experience navigating regulatory landscapes, understanding clinical workflows, and implementing scalable AI solutions in real-world healthcare environments.</p>
            <p className="text-lg text-gray-700 leading-relaxed">We are constantly pushing the boundaries of what&apos;s possible in healthcare AI. Our vision is to empower healthcare providers with intuitive, data-driven tools that enhance decision-making, optimize resource allocation, and ultimately elevate the standard of care.</p>
          </div>
        </div>
      </section>

      {/* Leadership Team */}
      <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Leadership Team</h2>
            <p className="text-xl text-gray-600">Driving innovation in healthcare technology</p>
          </div>
          <div className="space-y-12">
            {leadership.map((leader, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-xl overflow-hidden">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-0">
                  <div className="lg:col-span-1 bg-gradient-to-br from-blue-600 to-cyan-500 p-8 flex flex-col items-center justify-center text-center">
                    <div className="w-48 h-48 rounded-full overflow-hidden border-4 border-white shadow-2xl mb-6">
                      <img src={leader.image} alt={leader.name} className="w-full h-full object-cover" />
                    </div>
                    <h3 className="text-3xl font-bold text-white mb-2">{leader.name}</h3>
                    <p className="text-xl text-cyan-100 font-medium">{leader.title}</p>
                  </div>
                  <div className="lg:col-span-2 p-8 md:p-12">
                    <p className="text-lg text-gray-700 leading-relaxed mb-8">{leader.bio}</p>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      {leader.highlights.map((highlight, hIndex) => (
                        <div key={hIndex} className="bg-gradient-to-r from-blue-50 to-cyan-50 rounded-xl p-6 border border-blue-200">
                          <h4 className="text-lg font-bold text-blue-900 mb-2">{highlight.title}</h4>
                          <p className="text-gray-700">{highlight.desc}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Board of Advisors */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Board of Advisors</h2>
            <p className="text-xl text-gray-600">Distinguished healthcare leaders bringing decades of strategic insight and industry expertise</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {boardAdvisors.map((advisor, index) => (
              <div key={index} className="bg-gradient-to-br from-gray-50 to-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 border border-gray-200">
                <div className="p-8">
                  <div className="flex items-center gap-6 mb-6">
                    <div className="w-24 h-24 rounded-full overflow-hidden border-4 border-blue-500 shadow-lg flex-shrink-0">
                      <img src={advisor.image} alt={advisor.name} className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-1">{advisor.name}</h3>
                      <p className="text-sm text-gray-600 font-medium">{advisor.title}</p>
                    </div>
                  </div>
                  <p className="text-gray-700 leading-relaxed mb-6">{advisor.bio}</p>
                  <div className="space-y-3">
                    {advisor.highlights.map((highlight, hIndex) => (
                      <div key={hIndex} className="flex items-start gap-3">
                        <svg className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <p className="text-sm text-gray-600">{highlight}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Leadership Excellence */}
      <section className="py-16 bg-gradient-to-r from-blue-600 to-cyan-500">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-white text-center mb-12">Leadership Excellence</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-5xl mb-4">👨‍⚕️</div>
              <h3 className="text-xl font-bold text-white mb-2">Clinical Expertise</h3>
              <p className="text-cyan-100">Board-certified physicians with decades of frontline experience</p>
            </div>
            <div className="text-center">
              <div className="text-5xl mb-4">🤖</div>
              <h3 className="text-xl font-bold text-white mb-2">AI Innovation</h3>
              <p className="text-cyan-100">18+ years in data strategy and AI-driven analytics</p>
            </div>
            <div className="text-center">
              <div className="text-5xl mb-4">📈</div>
              <h3 className="text-xl font-bold text-white mb-2">Strategic Growth</h3>
              <p className="text-cyan-100">Proven track record in healthcare expansion and transformation</p>
            </div>
            <div className="text-center">
              <div className="text-5xl mb-4">🤝</div>
              <h3 className="text-xl font-bold text-white mb-2">Industry Relationships</h3>
              <p className="text-cyan-100">Deep connections across healthcare, finance, and technology sectors</p>
            </div>
          </div>
        </div>
      </section>

      {/* Join Our Mission */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">Join Our Mission</h2>
          <p className="text-xl text-gray-600 mb-12">Together, we&apos;re transforming healthcare through unified data intelligence, empowering providers, insurers, and legal firms with seamless access to actionable insights for a more insightful future of care.</p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div>
              <div className="text-4xl mb-3">🎯</div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Vision</h3>
              <p className="text-gray-600">Revolutionize healthcare through AI and data interoperability</p>
            </div>
            <div>
              <div className="text-4xl mb-3">💡</div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Innovation</h3>
              <p className="text-gray-600">Cutting-edge technology meets clinical excellence</p>
            </div>
            <div>
              <div className="text-4xl mb-3">🌟</div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Impact</h3>
              <p className="text-gray-600">Empowering better outcomes for patients and providers</p>
            </div>
          </div>
          <a href="mailto:info@caretapnexus.com" className="inline-block px-8 py-4 bg-gradient-to-r from-blue-600 to-cyan-500 text-white rounded-full font-semibold text-lg hover:shadow-xl hover:scale-105 transition-all duration-300">Contact Us: info@caretapnexus.com</a>
        </div>
      </section>
    </div>
  );
};

export default TeamPage;
